import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { getPayInOutReport } from "../../services/ReportApiService";
import DashboardTable from "./DashboardTable";
import { getPayInOutSummary } from "../../services/DashBoardApiService";
import dayjs from "dayjs";
import { DatatablePagingParameter, Filterclass } from "../../core/json/DatatablePagingParameters";

const PayInOutSection = ({ branch, StartingDate, EndingDate, decimalpoints = 2 }) => {
  const [payIn, setPayIn] = useState(0);
  const [payOut, setPayOut] = useState(0);
  const [error, setError] = useState("");
  const [groupedData, setGroupedData] = useState([]);
    const [loading, setloading] = useState(false);
      const [fromDate, setFromDate] = useState(dayjs());
      const [toDate, setToDate] = useState(dayjs());
      const [totalcount, settotalcount] = useState();
  const [stockData, setstockData] = useState();
  const [footerTotal, setFooterTotal] = useState(0);
 const [filteredData, setFilteredData] = useState(stockData);
   const [currentPage, setCurrentPage] = useState(1);
   const [pageSize, setPageSize] = useState(20); // Start with full data

   const handleStockInReport = async (page, size) => {
      const DatatablePagingParameters = new DatatablePagingParameter();
      DatatablePagingParameters.PageNumber = 1;
      DatatablePagingParameters.PageSize = -1;
      const formattedfromDate = dayjs(StartingDate).format("YYYY-MM-DD");
      const formattedtoDate = dayjs(EndingDate).format("YYYY-MM-DD");
      const Filters = new Filterclass();
      Filters.Branch = branch;
      Filters.FromDate = formattedfromDate;
      Filters.ToDate = formattedtoDate;
      try {
        const response = await getPayInOutReport({
          
          DatatablePagingParameters,
          Filters,
        });
        setstockData(response?.data?.payInOutReportDetail);
        setFilteredData(stockData);
        setFooterTotal(stockData?.reduce((sum, record) => sum + record.amount, 0));
        settotalcount(stockData?.length);
      } catch (error) {
        console.error(
          "Error Fetching Account Type!",
          error?.response?.data?.Message
        );
      }
    };
    const handleStockInfullReport = async () => {
      setloading(true);
      const DatatablePagingParameters = new DatatablePagingParameter();
      DatatablePagingParameters.PageNumber = 1;
      DatatablePagingParameters.PageSize = -1;
      const formattedfromDate = dayjs(StartingDate).format("YYYY-MM-DD");
      const formattedtoDate = dayjs(EndingDate).format("YYYY-MM-DD");
      const Filters = new Filterclass();
      Filters.Branch = branch;
      Filters.FromDate = formattedfromDate;
      Filters.ToDate = formattedtoDate;

  
      try {
        const response = await getPayInOutReport({
          DatatablePagingParameters,
          Filters,
        });
const rawData = response?.data?.payInOutReportDetail || [];
const summarized = summarizeDataByDate(rawData);

const totalPayIn = summarized.reduce((sum, item) => sum + item.payIn, 0);
const totalPayOut = summarized.reduce((sum, item) => sum + item.payOut, 0);

setstockData(summarized);
setFilteredData(summarized.slice(0, pageSize)); // Manual pagination
setFooterTotal(totalPayIn + totalPayOut);
settotalcount(summarized.length);
setPayIn(totalPayIn);     // <- for Pie Chart
setPayOut(totalPayOut);   // <- for Pie Chart

        // setstockData(response?.data?.payInOutReportDetail);
        // setFilteredData(response?.data?.payInOutReportDetail);
        // const totalCount = 0;
        // setFooterTotal(response?.data?.payInOutReportDetail?.reduce((sum, record) => sum + record.amount, 0));
        // // Set the total count
        // settotalcount(response?.data?.payInOutReportDetail?.length);
        setloading(false);
      } catch (error) {
        console.error(
          "Error Fetching Account Type!",
          error?.response?.data?.Message
        );
        setloading(false);
      }
    };
     useEffect(() => {
       handleStockInfullReport();
   }, [branch, StartingDate, EndingDate, decimalpoints]);
const summarizeDataByDate = (data) => {
  const summary = {};

  data.forEach((item) => {
    const dateKey = dayjs(item.date).format("YYYY-MM-DD");
    if (!summary[dateKey]) {
      summary[dateKey] = { date: dateKey, payIn: 0, payOut: 0 };
    }

    if (item.isPayIn === 1) {
      summary[dateKey].payOut += item.amount;
    } else {
      summary[dateKey].payIn += item.amount;
    }
  });

  return Object.values(summary);
};


  const seriesData = [
    { id: 0, value: payIn, label: "Pay In", color: "#4caf50" },
    { id: 1, value: payOut, label: "Pay Out", color: "#f44336" },
  ];

  // const columns = [
  //   {
  //     title: "Date",
  //     dataIndex: "date",
  //     key: "date",
  //     render: (text) => {
  //       const date = new Date(text);
  //       return date.toLocaleDateString("en-GB", {
  //         day: "2-digit",
  //         month: "short",
  //         year: "numeric",
  //       });
  //     },
  //   },
  //   {
  //     title: "Pay In",
  //     //dataIndex: "payIn",
  //     key: "payIn",
  //       render: (value) => (value === 1 ? 'Pay Out' : 'Pay In'), // conversion here,
  //   },
  //   {
  //     title: "Pay Out",
  //     //dataIndex: "payOut",
  //     key: "payOut",
  //       render: (value) => (value === 1 ? 'Pay Out' : 'Pay In'), // conversion here,
  //   },
  //   {
  //     title: "Total",
  //     dataIndex: "total",
  //     key: "total",
  //   },
  // ];
const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (text) => dayjs(text).format("DD-MMM-YYYY"),
  },
  {
    title: "Pay In",
    dataIndex: "payIn",
    key: "payIn",
    render: (value) => value?.toFixed(decimalpoints),
  },
  {
    title: "Pay Out",
    dataIndex: "payOut",
    key: "payOut",
    render: (value) => value?.toFixed(decimalpoints),
  },
  {
    title: "Total",
    key: "total",
    render: (_, record) =>
      (record.payIn + record.payOut).toFixed(decimalpoints),
  },
];

  console.log("filteredData", filteredData);


  return (
    <div className="pay-in-out-section">
    <div>
       <h4 >Pay In / Pay Out Summary</h4>
    </div>
     
      {error && <div style={{ color: "red" }}>{error}</div>}
    <div className="d-flex justify-content-center p-3">
   <PieChart
  series={[
    {
      data: [
        { id: 0, value: payIn, label: "Pay In", color: "#4caf50" },
        { id: 1, value: payOut, label: "Pay Out", color: "#f44336" },
      ],
      innerRadius: 30,
    },
  ]}
  width={400}
  height={200}
/>
</div>
      
      <DashboardTable
        dataSource={filteredData}
        columns={columns}
        loading={loading}
              id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
             pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount,
            onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                       handleStockInReport(page, size);
                        handleStockInfullReport();
                           },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
      />
    </div>
  );
};

export default PayInOutSection;
